/** @jsx jsx */
import React from 'react'
import { jsx } from 'theme-ui'
import { get } from 'lodash'
import { graphql } from 'gatsby'

import CTAs from '../components/ctas'
import Landing from '../components/landing'
import PageBlocks from '../components/page-blocks'
import PageWrapper from '../components/page-wrapper'
import SEO from '../components/seo'

import { resolveButtons } from '../lib/helpers'
import { FullsizeImage, InlineImage, ThumbnailImage } from '../lib/fragments'

import ActivatedParagraph from '../components/activated-paragraph'

const Page = (props) => {
  const { data } = props

  const landingArea = get(data, 'page.acfTemplatePage.landingArea')
  const title = get(data, 'page.title')
  const subheading = get(data, 'page.acfTemplatePage.subheading')
  const activatedParagraph = get(
    data,
    'page.acfTemplatePage.activatedParagraph'
  )
  const blocks = get(data, 'page.acfTemplatePage.pageBlocks')
  const ctas = get(data, 'page.acfTemplatePage.pageCtasCtas')

  const isActivatedParagraph = landingArea === 'activated' && activatedParagraph

  return (
    <PageWrapper>
      <Landing
        heading={!isActivatedParagraph ? title : null}
        subheading={!isActivatedParagraph ? subheading : null}
      >
        {isActivatedParagraph ? (
          <ActivatedParagraph paragraphs={activatedParagraph} />
        ) : null}
      </Landing>
      <PageBlocks blocks={blocks} />
      <CTAs ctas={ctas} />
    </PageWrapper>
  )
}

export const Head = ({ data }) => {
  return <SEO pageNode={data?.page} />
}

export const query = graphql`
  query ($id: String) {
    page: wpPage(id: { eq: $id }) {
      title
      uri
      seo {
        title
        metaDesc
        opengraphImage {
          ...ThumbnailImage
        }
      }
      template {
        templateName
      }
      acfTemplatePage {
        landingArea
        subheading
        activatedParagraph {
          heading
          paragraph
          buttons {
            linksTo
            label
            internalLink {
              ... on WpPage {
                id
                uri
              }
            }
            gradientColor
            externalLink
            email
            video
          }
        }
        pageBlocks {
          __typename
          ... on WpPage_Acftemplatepage_PageBlocks_Benefits {
            sectionColor
            heading
            subheading
            text
            video
            benefits {
              title
              text
              imageType
              mux
              image {
                ...InlineImage
              }
              buttons {
                linksTo
                label
                internalLink {
                  ... on WpPage {
                    id
                    uri
                  }
                }
                gradientColor
                externalLink
                email
                video
              }
            }
          }
          ... on WpPage_Acftemplatepage_PageBlocks_Cards {
            title
            subtitle
            sectionColor
            smallerText
            cards {
              image {
                ...InlineImage
              }
              title
              subtitle
              text
              buttons {
                linksTo
                label
                internalLink {
                  ... on WpPage {
                    id
                    uri
                  }
                }
                gradientColor
                externalLink
                email
                video
              }
            }
          }
          ... on WpPage_Acftemplatepage_PageBlocks_Detail {
            sectionColor
            heading
            subheading
            details {
              title
              detail
            }
            ctaText
            buttons {
              linksTo
              label
              internalLink {
                ... on WpPage {
                  id
                  uri
                }
              }
              gradientColor
              externalLink
              email
              video
            }
          }
          ... on WpPage_Acftemplatepage_PageBlocks_Text {
            heading
            video
            text
          }
          ... on WpPage_Acftemplatepage_PageBlocks_Hubspot {
            heading
            text
            portalId
            formId
          }
          ... on WpPage_Acftemplatepage_PageBlocks_Videos {
            videoGroups {
              heading
              subheading
              videos {
                type
                video
                embed
                imagePlaceholder {
                  ...InlineImage
                }
                linkUrl
                label
              }
            }
          }
          ... on WpPage_Acftemplatepage_PageBlocks_PricingDiagram {
            heading
            imageType
            mux
            image {
              ...InlineImage
            }
            parties {
              name
              about
              pays
            }
          }
          ... on WpPage_Acftemplatepage_PageBlocks_PricingTable {
            label
            table {
              tableHeader {
                highlight
                text
              }
              tableRows {
                rowLabel
                cells {
                  showTick
                  text
                  note
                }
              }
            }
            notes {
              note
              text
            }
          }
          ... on WpPage_Acftemplatepage_PageBlocks_VideoText {
            align
            sectionColor
            heading
            text
            video
            buttons {
              linksTo
              label
              internalLink {
                ... on WpPage {
                  id
                  uri
                }
              }
              gradientColor
              externalLink
              email
              video
            }
          }
          ... on WpPage_Acftemplatepage_PageBlocks_TextIcons {
            heading
            text
            icons {
              image {
                ...InlineImage
              }
              title
            }
          }
        }
        pageCtasCtas {
          cta {
            ... on WpCta {
              id
              uri
              title
              acfCTA {
                sectionColor
                textContent
                buttons {
                  linksTo
                  label
                  internalLink {
                    ... on WpPage {
                      id
                      uri
                    }
                  }
                  gradientColor
                  externalLink
                  email
                  video
                }
              }
            }
          }
        }
      }
    }
  }
`

export default Page
